import {
  Container,
  Header,
  SpaceBetween,
  Table,
  Box,
  Button,
  TableProps,
} from "@cloudscape-design/components-themed";
import { COMMON_LABELS } from "../default-constants";
import { IOrderTargetItems, LABELS } from "./constants";
import { useEffect, useState } from "react";
import {
  getOrderTargetsFilteredByExaminationStatus,
  isAfterJudgement,
} from "./util";
import TableEmptyState from "../UI/TableEmptyState";
import { 
  usePutReexaminationOrdersDecisionMutation,
  useLazyGetReexaminationOrdersVmExaminationCheckQuery 
} from "../../features/api";
import { 
  ReexaminationOrdersDecisionRequestItem,
  ReexaminationOrdersVmExaminationCheckRequest 
} from "../../features/api-interfaces";
import { addNotification } from "../../features/error/notifications-slice";
import { showModal } from "../UI/modal/modal-slice";
import { useAppDispatch } from "../../app/hook";
import { Messages } from "../../features/error/messages";

interface IExaminationResultsJudgement {
  examinationApplicationNo: string;
  isStore: boolean;
  columnDefinitions: TableProps.ColumnDefinition<IOrderTargetItems>[];
  items: IOrderTargetItems[];
  backOnClick: Function;
}

const ExaminationResultsJudgement = (props: IExaminationResultsJudgement) => {
  const {
    examinationApplicationNo,
    isStore,
    columnDefinitions,
    items,
    backOnClick,
  } = props;
  const dispatch = useAppDispatch();
  const [putReexaminationOrdersDecision] =
    usePutReexaminationOrdersDecisionMutation();
  const [getReexaminationOrdersVmExaminationCheck] = useLazyGetReexaminationOrdersVmExaminationCheckQuery();
  const [selectedItems, setSelectedItems] = useState<IOrderTargetItems[]>([]);
  const [selectedTargetNo, setSelectedTargetNo] = useState(0);
  const orderTargets = getOrderTargetsFilteredByExaminationStatus(items);
  const isAfterJudge = isAfterJudgement(items);

  useEffect(() => {
    const afterJudgeMentOrderTarget = items.find((item) => item.isApplied);
    if (afterJudgeMentOrderTarget) {
      setSelectedItems([afterJudgeMentOrderTarget]);
    }
  }, [items]);

  useEffect(() => {
    if (selectedItems.length !== 0) {
      if (selectedItems[0].orderTarget === LABELS.V_M_SMCC) {
        setSelectedTargetNo(1);
      } else if (selectedItems[0].orderTarget === LABELS.V_M_SAISON) {
        setSelectedTargetNo(2);
      } else {
        setSelectedTargetNo(3);
      }
    }
  }, [selectedItems]);

  /**
   * 判定ボタンを押したときの処理.
   */
  const judgeOnClick = () => {
    const requestData: ReexaminationOrdersVmExaminationCheckRequest = {
      examinationApplicationNo,
      orderTargetCode: selectedTargetNo,
    };
    getReexaminationOrdersVmExaminationCheck(requestData).then((result: any) => {
      if (result.data.vmCheckResultFlg) {
        dispatch(
          showModal({
            content: COMMON_LABELS.CONTENTS.JUDGEMENT,
            positiveFn: () => {
              const requestData: ReexaminationOrdersDecisionRequestItem = {
                examinationApplicationNo,
                data: {
                  applicationBrand: selectedTargetNo,
                },
              };
              putReexaminationOrdersDecision(requestData).then((result: any) => {
                if ("error" in result && "data" in result.error) {
                  const { messageId, errorDetail } = result.error.data;
                  if (messageId) {
                    dispatch(
                      addNotification({
                        msgId: messageId,
                        msgArgs: errorDetail ?? [],
                      })
                    );
                  }
                } else {
                  backOnClick();
                }
              });
            },
          })
        );
      } else {
        const messageId = "KGRERR148" as keyof Messages;
        dispatch(
          addNotification({
            msgId: messageId,
            msgArgs: [],
          })
        );
      }
    })
    
  };


  return (
    <Container header={<Header>{LABELS.SUB_TITLE_RIGHT}</Header>}>
      <SpaceBetween direction={"vertical"} size={"s"}>
        <Table
          selectionType={"single"}
          onSelectionChange={({ detail }) =>
            setSelectedItems(detail.selectedItems)
          }
          selectedItems={selectedItems}
          columnDefinitions={columnDefinitions}
          items={orderTargets}
          isItemDisabled={() =>
            isStore || orderTargets.length === 0 || isAfterJudge
          }
          empty={<TableEmptyState />}
          resizableColumns
        />
        <Box textAlign={"right"}>
          <Button
            formAction={"none"}
            variant={"primary"}
            onClick={judgeOnClick}
            disabled={
            isStore ||
            orderTargets.length === 0 ||
            selectedItems.length === 0 ||
            isAfterJudge
            }
          >
            {COMMON_LABELS.BTNS.JUDGE}
          </Button>
        </Box>
      </SpaceBetween>
    </Container>
  );
};

export default ExaminationResultsJudgement;
